import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import {
    Users, Trash2, Edit, ChevronLeft,
    Calendar, MapPin, Palette, Plus, Save,
    Trophy, Flag, CheckCircle, X, Image as ImageIcon // <--- DODAJ TO
} from "lucide-react";
// DODAJ IMPORTY:
import { useSearchParams } from "react-router-dom";
// ==========================================
// STYLED COMPONENTS (WSPÓŁDZIELONE)
// ==========================================

const ManagerContainer = styled.div`
  width: 100%;
`;

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;

  h2 {
    margin: 0;
    font-size: 1.8rem;
    color: #111;
    font-weight: 800;
  }
`;

const PrimaryButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #111;
  color: #fff;
  padding: 10px 18px;
  border: none;
  border-radius: 8px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s;

  &:hover { background: #333; transform: translateY(-2px); }
  &:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }
`;

const SecondaryButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  color: #111;
  padding: 10px 18px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;

  &:hover { background: #f4f6f8; }
`;

const ActionBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.85rem;
  cursor: pointer;
  transition: 0.2s;

  &.edit { background: #f0f4ff; color: #234ffc; }
  &.edit:hover { background: #dce5ff; }

  &.delete { background: #fff0f0; color: #dc3545; }
  &.delete:hover { background: #ffe0e0; }

  &.success { background: #eafbf0; color: #28a745; }
  &.success:hover { background: #d0f4db; }
`;

// --- KARTY FORMULARZY ---

const FormCard = styled.form`
  background: #fff;
  border-radius: 12px;
  padding: 30px;
  border: 1px solid #eee;
  box-shadow: 0 4px 15px rgba(0,0,0,0.03);
  margin-bottom: 30px;
`;

const FormSectionTitle = styled.h4`
  margin: 0 0 20px 0;
  font-size: 1.1rem;
  color: #111;
  border-bottom: 2px solid #f0f0f0;
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  svg { color: #888; }
`;

const FormGroupGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  label { font-size: 0.9rem; font-weight: 700; color: #555; }
  input, select {
    padding: 10px 14px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 1rem;
    font-family: inherit;
    transition: border-color 0.3s;
    &:focus { outline: none; border-color: #111; }
  }
`;

// --- LISTY DANYCH ---

const DataList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 15px;
`;

const DataItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: #fdfdfd;
  border: 1px solid #eee;
  border-radius: 8px;

  .info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    strong { color: #111; font-size: 1.05rem; }
    span { color: #666; font-size: 0.9rem; }
  }

  .actions { display: flex; gap: 8px; }

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
    .actions { width: 100%; justify-content: flex-end; }
  }
`;

// ==========================================
// SUB-MENEDŻERY (WEWNĘTRZNE)
// ==========================================

// 1. MIEJSCA GIER
const LocationsManager = ({ rocznikId }) => {
    const [miejsca, setMiejsca] = useState([]);
    const [formData, setFormData] = useState({ nazwa: "", adres: "" });
    const [loading, setLoading] = useState(false);

    const fetchMiejsca = async () => {
        try {
            const res = await fetch(`https://api.pth-hokej.pl/api/roczniki/${rocznikId}/miejscaGier`);
            setMiejsca(await res.json());
        } catch (err) { console.error(err); }
    };

    useEffect(() => { fetchMiejsca(); }, [rocznikId]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await fetch(`https://api.pth-hokej.pl/api/roczniki/${rocznikId}/miejscaGier`, {
                method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(formData),
            });
            setFormData({ nazwa: "", adres: "" });
            fetchMiejsca();
        } catch (err) { console.error(err); } finally { setLoading(false); }
    };

    const handleDelete = async (index) => {
        if (!window.confirm("Usunąć to miejsce?")) return;
        await fetch(`https://api.pth-hokej.pl/api/roczniki/${rocznikId}/miejscaGier/${index}`, { method: "DELETE" });
        fetchMiejsca();
    };

    return (
        <FormCard onSubmit={handleSubmit}>
            <FormSectionTitle><MapPin size={20} /> Miejsca Gier (Lokalizacje domowe)</FormSectionTitle>
            <FormGroupGrid>
                <FormGroup>
                    <label>Nazwa lodowiska</label>
                    <input name="nazwa" required value={formData.nazwa} onChange={(e) => setFormData({ ...formData, nazwa: e.target.value })} placeholder="np. Chwiałka" />
                </FormGroup>
                <FormGroup>
                    <label>Dokładny adres</label>
                    <input name="adres" required value={formData.adres} onChange={(e) => setFormData({ ...formData, adres: e.target.value })} placeholder="np. ul. Chwiałkowskiego 34" />
                </FormGroup>
            </FormGroupGrid>
            <PrimaryButton type="submit" disabled={loading}><Plus size={16} /> Dodaj Lokalizację</PrimaryButton>

            {miejsca.length > 0 && (
                <DataList>
                    {miejsca.map((m, idx) => (
                        <DataItem key={idx}>
                            <div className="info"><strong>{m.nazwa}</strong><span>{m.adres}</span></div>
                            <div className="actions"><ActionBtn type="button" className="delete" onClick={() => handleDelete(idx)}><Trash2 size={16} /> Usuń</ActionBtn></div>
                        </DataItem>
                    ))}
                </DataList>
            )}
        </FormCard>
    );
};

// 2. MENEDŻER MECZÓW
const MatchesManager = ({ rocznikId }) => {
    const [matches, setMatches] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [logoFile, setLogoFile] = useState(null); // Nowy stan dla pliku
    const [formData, setFormData] = useState({ opponentName: "", opponentLogo: "", date: "", time: "", address: "" });

    const fetchMatches = async () => {
        try {
            const res = await fetch(`https://api.pth-hokej.pl/api/matches/rocznik/${rocznikId}`);
            setMatches(await res.json());
        } catch (err) { console.error(err); }
    };

    useEffect(() => { fetchMatches(); }, [rocznikId]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const url = editingId ? `https://api.pth-hokej.pl/api/matches/${editingId}` : `https://api.pth-hokej.pl/api/matches`;
            const method = editingId ? "PUT" : "POST";

            // Używamy FormData zamiast JSON.stringify
            const submitData = new FormData();
            submitData.append("rocznik", rocznikId);
            submitData.append("opponentName", formData.opponentName);
            submitData.append("date", formData.date);
            submitData.append("time", formData.time);
            submitData.append("address", formData.address);

            // Jeśli wybrano plik z dysku, dodajemy go pod kluczem 'opponentLogoFile'
            if (logoFile) {
                submitData.append("opponentLogoFile", logoFile);
            } else if (formData.opponentLogo) {
                // Jeśli nie, a wpisano URL, to wysyłamy URL
                submitData.append("opponentLogo", formData.opponentLogo);
            }

            await fetch(url, {
                method,
                // UWAGA: Przy FormData nie ustawiamy ręcznie nagłówka "Content-Type". Przeglądarka robi to sama.
                body: submitData,
            });

            setFormData({ opponentName: "", opponentLogo: "", date: "", time: "", address: "" });
            setLogoFile(null);
            setEditingId(null);
            fetchMatches();
        } catch (err) { console.error(err); } finally { setLoading(false); }
    };

    const handleEdit = (m) => {
        setEditingId(m._id);
        setLogoFile(null); // Resetujemy plik przy wejściu w edycję
        setFormData({ opponentName: m.opponentName || "", opponentLogo: m.opponentLogo || "", date: m.date || "", time: m.time || "", address: m.address || "" });
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Usunąć ten mecz?")) return;
        await fetch(`https://api.pth-hokej.pl/api/matches/${id}`, { method: "DELETE" });
        fetchMatches();
    };

    return (
        <FormCard onSubmit={handleSubmit}>
            <FormSectionTitle><Calendar size={20} /> {editingId ? "Edytuj Zaplanowany Mecz" : "Dodaj Zaplanowany Mecz"}</FormSectionTitle>
            <FormGroupGrid>
                <FormGroup>
                    <label>Przeciwnik</label>
                    <input name="opponentName" required value={formData.opponentName} onChange={(e) => setFormData({ ...formData, opponentName: e.target.value })} placeholder="np. Sokoły Toruń" />
                </FormGroup>
                <FormGroup>
                    <label>Data i Godzina</label>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <input style={{ flex: 2 }} name="date" type="date" required value={formData.date} onChange={(e) => setFormData({ ...formData, date: e.target.value })} />
                        <input style={{ flex: 1 }} name="time" type="time" required value={formData.time} onChange={(e) => setFormData({ ...formData, time: e.target.value })} />
                    </div>
                </FormGroup>

                <FormGroup>
                    <label>Adres lodowiska</label>
                    <input name="address" required value={formData.address} onChange={(e) => setFormData({ ...formData, address: e.target.value })} placeholder="Adres..." />
                </FormGroup>

                <FormGroup style={{ gridColumn: '1 / -1', background: '#fafafa', padding: '15px', borderRadius: '8px', border: '1px solid #eee' }}>
                    <label style={{ marginBottom: '5px' }}>Logo przeciwnika (Wybierz jedną opcję)</label>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', alignItems: 'center' }}>
                        <div>
                            <span style={{ fontSize: '0.8rem', color: '#888', display: 'block', marginBottom: '5px' }}>Opcja 1: Wgraj plik z komputera</span>
                            <input type="file" accept="image/*" onChange={(e) => setLogoFile(e.target.files[0])} style={{ padding: '8px', background: '#fff', width: '100%' }} disabled={!!formData.opponentLogo} />
                        </div>
                        <div>
                            <span style={{ fontSize: '0.8rem', color: '#888', display: 'block', marginBottom: '5px' }}>Opcja 2: Wklej link do zdjęcia (URL)</span>
                            <input name="opponentLogo" value={formData.opponentLogo} onChange={(e) => setFormData({ ...formData, opponentLogo: e.target.value })} placeholder="https://..." disabled={!!logoFile} style={{ width: '100%', boxSizing: 'border-box' }} />
                        </div>
                    </div>
                </FormGroup>

            </FormGroupGrid>

            <div style={{ display: 'flex', gap: '10px' }}>
                <PrimaryButton type="submit" disabled={loading}>{editingId ? <Save size={16} /> : <Plus size={16} />} {editingId ? "Zapisz Zmiany" : "Zaplanuj Mecz"}</PrimaryButton>
                {editingId && <SecondaryButton type="button" onClick={() => { setEditingId(null); setFormData({ opponentName: "", opponentLogo: "", date: "", time: "", address: "" }); setLogoFile(null); }}><X size={16} /> Anuluj</SecondaryButton>}
            </div>

            {matches.length > 0 && (
                <DataList>
                    {matches.map(m => (
                        <DataItem key={m._id}>
                            <div className="info" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                {m.opponentLogo && <img src={m.opponentLogo} alt="Logo" style={{ width: '30px', height: '30px', objectFit: 'contain' }} />}
                                <div>
                                    <strong>VS {m.opponentName}</strong>
                                    <span>{m.date} o {m.time} | {m.address}</span>
                                </div>
                            </div>
                            <div className="actions">
                                <ActionBtn type="button" className="edit" onClick={() => handleEdit(m)}><Edit size={16} /> Edytuj</ActionBtn>
                                <ActionBtn type="button" className="delete" onClick={() => handleDelete(m._id)}><Trash2 size={16} /> Usuń</ActionBtn>
                            </div>
                        </DataItem>
                    ))}
                </DataList>
            )}
        </FormCard>
    );
};

// 3. MENEDŻER WYNIKÓW
const ResultsManager = ({ rocznikId }) => {
    const [wyniki, setWyniki] = useState([]);
    const [finishedMatches, setFinishedMatches] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedMatchId, setSelectedMatchId] = useState(null);
    const [logoFile, setLogoFile] = useState(null); // Nowy stan dla pliku
    const [formData, setFormData] = useState({ rywal: "", punktyN: "", punktyR: "", logoRywal: "", kolorRywal: "#234ffc" });

    const fetchData = async () => {
        try {
            const resWyniki = await fetch(`https://api.pth-hokej.pl/api/roczniki/${rocznikId}/wyniki`);
            setWyniki(await resWyniki.json());

            const resMatches = await fetch(`https://api.pth-hokej.pl/api/matches/rocznik/${rocznikId}`);
            const matchesData = await resMatches.json();
            const finished = matchesData.filter(m => {
                const matchDateTime = new Date(`${m.date}T${m.time}`);
                return matchDateTime <= new Date(Date.now() - 2 * 60 * 60 * 1000);
            });
            setFinishedMatches(finished);
        } catch (err) { console.error(err); }
    };

    useEffect(() => { fetchData(); }, [rocznikId]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            // Używamy FormData
            const submitData = new FormData();
            submitData.append("rywal", formData.rywal);
            submitData.append("punktyN", formData.punktyN);
            submitData.append("punktyR", formData.punktyR);
            submitData.append("kolorRywal", formData.kolorRywal);

            if (logoFile) {
                submitData.append("logoRywalFile", logoFile);
            } else if (formData.logoRywal) {
                submitData.append("logoRywal", formData.logoRywal);
            }

            await fetch(`https://api.pth-hokej.pl/api/roczniki/${rocznikId}/wyniki`, {
                method: "POST",
                body: submitData,
            });

            if (selectedMatchId) {
                await fetch(`https://api.pth-hokej.pl/api/matches/${selectedMatchId}`, { method: "DELETE" });
                setSelectedMatchId(null);
            }
            setFormData({ rywal: "", punktyN: "", punktyR: "", logoRywal: "", kolorRywal: "#234ffc" });
            setLogoFile(null);
            fetchData();
        } catch (err) { console.error(err); } finally { setLoading(false); }
    };

    const handleSelectMatch = (m) => {
        setSelectedMatchId(m._id);
        setLogoFile(null);
        setFormData({ rywal: m.opponentName || "", punktyN: "", punktyR: "", logoRywal: m.opponentLogo || "", kolorRywal: "#234ffc" });
    };

    return (
        <FormCard onSubmit={handleSubmit}>
            <FormSectionTitle><Trophy size={20} /> Wyniki i Zakończone Mecze</FormSectionTitle>

            {finishedMatches.length > 0 && (
                <div style={{ marginBottom: '30px', padding: '15px', background: '#fff9e6', border: '1px solid #ffeeba', borderRadius: '8px' }}>
                    <h5 style={{ margin: '0 0 10px 0', color: '#856404' }}>Mecze oczekujące na wpisanie wyniku:</h5>
                    <DataList style={{ marginTop: 0 }}>
                        {finishedMatches.map(m => (
                            <DataItem key={m._id} style={{ background: '#fff' }}>
                                <div className="info"><strong>VS {m.opponentName}</strong><span>Rozegrano: {m.date}</span></div>
                                <div className="actions">
                                    <ActionBtn type="button" className="success" onClick={() => handleSelectMatch(m)}><CheckCircle size={16} /> Wpisz wynik</ActionBtn>
                                </div>
                            </DataItem>
                        ))}
                    </DataList>
                </div>
            )}

            <FormGroupGrid>
                <FormGroup style={{ gridColumn: '1 / -1' }}>
                    <label>Nazwa Rywala</label>
                    <input name="rywal" required value={formData.rywal} onChange={(e) => setFormData({ ...formData, rywal: e.target.value })} />
                </FormGroup>

                <FormGroup style={{ gridColumn: '1 / -1', background: '#fafafa', padding: '15px', borderRadius: '8px', border: '1px solid #eee' }}>
                    <label style={{ marginBottom: '5px' }}>Logo rywala (Wybierz jedną opcję)</label>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', alignItems: 'center' }}>
                        <div>
                            <span style={{ fontSize: '0.8rem', color: '#888', display: 'block', marginBottom: '5px' }}>Opcja 1: Wgraj plik</span>
                            <input type="file" accept="image/*" onChange={(e) => setLogoFile(e.target.files[0])} style={{ padding: '8px', background: '#fff', width: '100%' }} disabled={!!formData.logoRywal} />
                        </div>
                        <div>
                            <span style={{ fontSize: '0.8rem', color: '#888', display: 'block', marginBottom: '5px' }}>Opcja 2: Wklej URL</span>
                            <input name="logoRywal" value={formData.logoRywal} onChange={(e) => setFormData({ ...formData, logoRywal: e.target.value })} placeholder="https://..." disabled={!!logoFile} style={{ width: '100%', boxSizing: 'border-box' }} />
                        </div>
                    </div>
                </FormGroup>

                <FormGroup>
                    <label>Nasze Punkty</label>
                    <input name="punktyN" type="number" required value={formData.punktyN} onChange={(e) => setFormData({ ...formData, punktyN: e.target.value })} />
                </FormGroup>
                <FormGroup>
                    <label>Punkty Rywala</label>
                    <input name="punktyR" type="number" required value={formData.punktyR} onChange={(e) => setFormData({ ...formData, punktyR: e.target.value })} />
                </FormGroup>
                <FormGroup>
                    <label>Kolor Rywala (np. na tło wyniku)</label>
                    <input type="color" name="kolorRywal" value={formData.kolorRywal} onChange={(e) => setFormData({ ...formData, kolorRywal: e.target.value })} style={{ height: '40px', padding: '2px', width: '100%' }} />
                </FormGroup>
            </FormGroupGrid>
            <PrimaryButton type="submit" disabled={loading}><Plus size={16} /> {selectedMatchId ? "Zapisz Wynik Meczu" : "Dodaj Wynik Ręcznie"}</PrimaryButton>

            {wyniki.length > 0 && (
                <DataList style={{ marginTop: '30px' }}>
                    {wyniki.map((w, idx) => (
                        <DataItem key={idx}>
                            <div className="info" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '15px' }}>
                                {w.logoRywal ? (
                                    <img src={w.logoRywal} alt="Logo" style={{ width: '25px', height: '25px', objectFit: 'contain' }} />
                                ) : (
                                    <div style={{ width: '15px', height: '15px', borderRadius: '50%', background: w.kolorRywal }}></div>
                                )}
                                <strong>Wilki {w.punktyN} : {w.punktyR} {w.rywal}</strong>
                            </div>
                        </DataItem>
                    ))}
                </DataList>
            )}
        </FormCard>
    );
};

// ==========================================
// GŁÓWNY KOMPONENT: ROCZNIKI MANAGER
// ==========================================

const TeamsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
`;

const TeamCard = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 25px;
  border: 1px solid #eee;
  box-shadow: 0 4px 15px rgba(0,0,0,0.03);
  display: flex;
  flex-direction: column;
  gap: 15px;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    h3 { margin: 0; font-size: 1.4rem; font-weight: 800; color: #111; }
    .colors { display: flex; gap: 5px; .color-dot { width: 16px; height: 16px; border-radius: 50%; border: 1px solid #ddd; } }
  }

  .info-row {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #666;
    font-size: 0.95rem;
    svg { width: 18px; height: 18px; color: #999; }
    strong { color: #111; }
  }

  .actions {
    display: flex; gap: 10px; margin-top: 10px; padding-top: 15px; border-top: 1px solid #f0f0f0;
    button { flex: 1; display: flex; justify-content: center; align-items: center; gap: 5px; padding: 10px; border: none; border-radius: 6px; font-weight: 600; cursor: pointer; transition: 0.2s; }
    .btn-edit { background: #f0f4ff; color: #234ffc; }
    .btn-edit:hover { background: #dce5ff; }
    .btn-delete { background: #fff0f0; color: #dc3545; }
    .btn-delete:hover { background: #ffe0e0; }
  }
`;

const DaysRow = styled.div` display: flex; flex-wrap: wrap; gap: 10px; `;
const DayChip = styled.div`
  padding: 10px 15px; border-radius: 8px; font-weight: 600; font-size: 0.9rem; cursor: pointer;
  border: 1px solid ${props => props.active ? '#111' : '#ddd'};
  background: ${props => props.active ? '#111' : '#fff'};
  color: ${props => props.active ? '#fff' : '#666'};
  transition: all 0.2s;
  &:hover { border-color: #111; }
`;

const daysMap = [
    { val: 1, label: "Pn" }, { val: 2, label: "Wt" }, { val: 3, label: "Śr" },
    { val: 4, label: "Cz" }, { val: 5, label: "Pt" }, { val: 6, label: "Sb" }, { val: 0, label: "Nd" }
];

export default function RocznikManager() {
    const [roczniki, setRoczniki] = useState([]);

    const [searchParams, setSearchParams] = useSearchParams();
    const viewState = searchParams.get("action") || "list";
    const editingId = searchParams.get("id") || null;

    const [loading, setLoading] = useState(false);
    
    // Zaktualizowany stan o zdjecieDruzyny
    const [formData, setFormData] = useState({
        rocznik: "", trener: "", liczbaZawodników: "", miejsceTreningów: "", dniTreningow: [], kolor1: "#234ffc", kolor2: "#123eeb", zdjecieDruzyny: ""
    });
    
    // Nowy stan na fizyczny plik z komputera
    const [imageFile, setImageFile] = useState(null); 

    const dataLoadedRef = useRef(null);

    const fetchRoczniki = async () => {
        try {
            const res = await fetch("https://api.pth-hokej.pl/api/roczniki");
            setRoczniki(await res.json());
        } catch (err) { console.error(err); }
    };

    useEffect(() => { fetchRoczniki(); }, []);

    useEffect(() => {
        if (viewState === "edit" && editingId && roczniki.length > 0) {
            if (dataLoadedRef.current !== editingId) {
                const r = roczniki.find(item => item._id === editingId);
                if (r) {
                    setFormData({
                        rocznik: r.rocznik || "", 
                        trener: r.trener || "", 
                        liczbaZawodników: r.liczbaZawodników || "",
                        miejsceTreningów: r.miejsceTreningów || "", 
                        dniTreningow: r.dniTreningow || [], 
                        kolor1: r.kolor1 || "#234ffc", 
                        kolor2: r.kolor2 || "#123eeb",
                        zdjecieDruzyny: r.zdjecieDruzyny || ""
                    });
                    setImageFile(null); // Czyszczenie pliku przy ładowaniu
                    dataLoadedRef.current = editingId;
                }
            }
        } else if (viewState === "list") {
            dataLoadedRef.current = null;
        }
    }, [viewState, editingId, roczniki]);

    const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
    const toggleDay = (dayVal) => {
        setFormData(prev => ({
            ...prev, dniTreningow: prev.dniTreningow.includes(dayVal) ? prev.dniTreningow.filter(d => d !== dayVal) : [...prev.dniTreningow, dayVal]
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const url = viewState === "edit" && editingId ? `https://api.pth-hokej.pl/api/roczniki/${editingId}` : "https://api.pth-hokej.pl/api/roczniki";
            const method = viewState === "edit" && editingId ? "PUT" : "POST";

            // UŻYCIE FORMDATA DO WYSYŁKI ZDJĘĆ
            const submitData = new FormData();
            submitData.append("rocznik", formData.rocznik);
            submitData.append("trener", formData.trener);
            submitData.append("liczbaZawodników", formData.liczbaZawodników);
            submitData.append("miejsceTreningów", formData.miejsceTreningów);
            submitData.append("dniTreningow", JSON.stringify(formData.dniTreningow)); // zamieniamy tablice w string
            submitData.append("kolor1", formData.kolor1);
            submitData.append("kolor2", formData.kolor2);

            if (imageFile) {
                submitData.append("zdjeciePlik", imageFile);
            } else if (formData.zdjecieDruzyny) {
                submitData.append("zdjecieDruzyny", formData.zdjecieDruzyny);
            } else {
                submitData.append("zdjecieDruzyny", ""); 
            }

            await fetch(url, {
                method,
                body: submitData
            });

            await fetchRoczniki();
            setSearchParams({});
        } catch (err) { console.error(err); } finally { setLoading(false); }
    };

    const handleAddClick = () => {
        setFormData({ rocznik: "", trener: "", liczbaZawodników: "", miejsceTreningów: "", dniTreningow: [], kolor1: "#234ffc", kolor2: "#123eeb", zdjecieDruzyny: "" });
        setImageFile(null);
        setSearchParams({ action: "add" });
    };

    const handleEditClick = (r) => {
        setFormData({ 
            rocznik: r.rocznik || "", trener: r.trener || "", liczbaZawodników: r.liczbaZawodników || "", 
            miejsceTreningów: r.miejsceTreningów || "", dniTreningow: r.dniTreningow || [], kolor1: r.kolor1 || "#234ffc", kolor2: r.kolor2 || "#123eeb", zdjecieDruzyny: r.zdjecieDruzyny || ""
        });
        setImageFile(null);
        dataLoadedRef.current = r._id;
        setSearchParams({ action: "edit", id: r._id });
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Usunąć ten rocznik ze wszystkimi danymi?")) return;
        await fetch(`https://api.pth-hokej.pl/api/roczniki/${id}`, { method: "DELETE" });
        fetchRoczniki();
    };

    const getDaysString = (arr) => arr?.length ? arr.map(d => daysMap.find(m => m.val === d)?.label).filter(Boolean).join(", ") : "Brak";

    return (
        <ManagerContainer>
            {viewState === "list" && (
                <>
                    <HeaderRow>
                        <h2>Zarządzanie Rocznikami</h2>
                        <PrimaryButton onClick={handleAddClick}>
                            <Plus size={20} /> Dodaj Rocznik
                        </PrimaryButton>
                    </HeaderRow>

                    <TeamsGrid>
                        {roczniki.map((r) => (
                            <TeamCard key={r._id}>
                                {/* WYŚWIETLANIE MINIATURKI ZDJĘCIA W LIŚCIE */}
                                {r.zdjecieDruzyny && (
                                    <div style={{ width: '100%', height: '140px', borderRadius: '8px', overflow: 'hidden', marginBottom: '10px' }}>
                                        <img src={r.zdjecieDruzyny} alt={`Drużyna ${r.rocznik}`} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                    </div>
                                )}
                                
                                <div className="header">
                                    <h3>Wilki {r.rocznik}</h3>
                                    <div className="colors">
                                        {r.kolor1 && <div className="color-dot" style={{ backgroundColor: r.kolor1 }} />}
                                        {r.kolor2 && <div className="color-dot" style={{ backgroundColor: r.kolor2 }} />}
                                    </div>
                                </div>
                                <div className="info-row"><Users /> <span>Trener: <strong>{r.trener || "Brak"}</strong> ({r.liczbaZawodników || 0} zaw.)</span></div>
                                <div className="info-row"><MapPin /> <span>{r.miejsceTreningów || "Nie ustawiono"}</span></div>
                                <div className="info-row"><Calendar /> <span>Treningi: <strong>{getDaysString(r.dniTreningow)}</strong></span></div>
                                <div className="actions">
                                    <button className="btn-edit" onClick={() => handleEditClick(r)}><Edit size={16} /> Edytuj</button>
                                    <button className="btn-delete" onClick={() => handleDelete(r._id)}><Trash2 size={16} /> Usuń</button>
                                </div>
                            </TeamCard>
                        ))}
                    </TeamsGrid>
                </>
            )}

            {(viewState === "add" || viewState === "edit") && (
                <>
                    <HeaderRow>
                        <SecondaryButton onClick={() => setSearchParams({})}>
                            <ChevronLeft size={20} /> Wróć do listy
                        </SecondaryButton>
                        <h2>{viewState === "edit" ? `Edytujesz: Wilki ${formData.rocznik}` : "Nowy Rocznik"}</h2>
                    </HeaderRow>

                    <FormCard onSubmit={handleSubmit}>
                        <FormSectionTitle><Users size={20} /> Dane podstawowe</FormSectionTitle>
                        <FormGroupGrid>
                            <FormGroup><label>Rocznik (np. 2008)</label><input required name="rocznik" value={formData.rocznik} onChange={handleChange} /></FormGroup>
                            <FormGroup><label>Trener</label><input name="trener" value={formData.trener} onChange={handleChange} /></FormGroup>
                            <FormGroup><label>Liczba zawodników</label><input name="liczbaZawodników" type="number" value={formData.liczbaZawodników} onChange={handleChange} /></FormGroup>
                        </FormGroupGrid>

                        <FormSectionTitle><Calendar size={20} /> Treningi i Miejsce</FormSectionTitle>
                        <FormGroupGrid>
                            <FormGroup><label>Główne miejsce treningów</label><input name="miejsceTreningów" value={formData.miejsceTreningów} onChange={handleChange} /></FormGroup>
                            <FormGroup style={{ gridColumn: '1 / -1' }}>
                                <label>Dni treningowe w tygodniu</label>
                                <DaysRow>
                                    {daysMap.map(d => <DayChip key={d.val} active={formData.dniTreningow.includes(d.val)} onClick={() => toggleDay(d.val)}>{d.label}</DayChip>)}
                                </DaysRow>
                            </FormGroup>
                        </FormGroupGrid>

                        {/* NOWA SEKCJA ZDJĘCIA */}
                        <FormSectionTitle><ImageIcon size={20} /> Zdjęcie Drużyny</FormSectionTitle>
                        <FormGroup style={{ background: '#fafafa', padding: '20px', borderRadius: '8px', border: '1px solid #eee', marginBottom: '30px' }}>
                            <label style={{ marginBottom: '10px' }}>Wybierz zdjęcie drużyny (pojawia się na podstronie rocznika)</label>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', alignItems: 'center' }}>
                                <div>
                                    <span style={{ fontSize: '0.85rem', color: '#888', display: 'block', marginBottom: '8px' }}>Opcja 1: Wgraj zdjęcie z komputera</span>
                                    <input 
                                        type="file" 
                                        accept="image/*" 
                                        onChange={(e) => setImageFile(e.target.files[0])} 
                                        style={{ padding: '8px', background: '#fff', width: '100%', boxSizing: 'border-box' }} 
                                        disabled={!!formData.zdjecieDruzyny} 
                                    />
                                </div>
                                <div>
                                    <span style={{ fontSize: '0.85rem', color: '#888', display: 'block', marginBottom: '8px' }}>Opcja 2: Wklej link do zdjęcia</span>
                                    <input 
                                        name="zdjecieDruzyny" 
                                        value={formData.zdjecieDruzyny} 
                                        onChange={handleChange} 
                                        placeholder="https://..." 
                                        disabled={!!imageFile} 
                                        style={{ width: '100%', boxSizing: 'border-box' }}
                                    />
                                </div>
                            </div>
                        </FormGroup>

                        <FormSectionTitle><Palette size={20} /> Kolorystyka drużyny</FormSectionTitle>
                        <FormGroupGrid>
                            <FormGroup><label>Kolor główny (Gradient 1)</label><input type="color" name="kolor1" value={formData.kolor1} onChange={handleChange} style={{ height: '45px', padding: '2px' }} /></FormGroup>
                            <FormGroup><label>Kolor dodatkowy (Gradient 2)</label><input type="color" name="kolor2" value={formData.kolor2} onChange={handleChange} style={{ height: '45px', padding: '2px' }} /></FormGroup>
                        </FormGroupGrid>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                            <PrimaryButton type="submit" disabled={loading}><Save size={20} /> Zapisz Rocznik</PrimaryButton>
                        </div>
                    </FormCard>

                    {viewState === "edit" && editingId && (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
                            <MatchesManager rocznikId={editingId} />
                            <ResultsManager rocznikId={editingId} />
                            <LocationsManager rocznikId={editingId} />
                        </div>
                    )}
                </>
            )}
        </ManagerContainer>
    );
}